import { Boundaries } from "@planzone/core";
import { State } from "./types";

function handleEditUnavailabilityRequest(
  state: State,
  {
    unavailability,
    nextUnavailability,
  }: Boundaries["editUnavailability"]["request"],
): State {
  return state.map((req) => ({
    ...req,
    calendar: {
      ...req.calendar,
      unavailabilities: req.calendar.unavailabilities.map((u) =>
        unavailability.uuid === u.uuid ? { ...u, ...nextUnavailability } : u,
      ),
    },
  }));
}

function handleEditUnavailabilitySuccess(
  state: State,
  unavailability: Boundaries["editUnavailability"]["success"],
): State {
  return state.map((req) => ({
    ...req,
    calendar: {
      ...req.calendar,
      unavailabilities: req.calendar.unavailabilities.map((u) =>
        unavailability.uuid === u.uuid ? unavailability : u,
      ),
    },
  }));
}

function handleEditUnavailabilityFailure(
  state: State,
  { unavailability }: Boundaries["editUnavailability"]["failure"],
): State {
  return state.map((req) => ({
    ...req,
    calendar: {
      ...req.calendar,
      unavailabilities: req.calendar.unavailabilities.map((u) =>
        unavailability.uuid !== u.uuid ? { ...u, ...unavailability } : u,
      ),
    },
  }));
}

export {
  handleEditUnavailabilityRequest,
  handleEditUnavailabilitySuccess,
  handleEditUnavailabilityFailure,
};
